// extracted by mini-css-extract-plugin
export default {"icons":"ConditionsCard_icons__V20d0","greyText":"ConditionsCard_greyText__N+UNi"};